import {
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { Link } from "react-router-dom";
import SocialRating from "./SocialRating";

const SocialCompanyListItemShort = ({ object: companyWeight }) => {
  return (
    <Link
      to={`/company/${companyWeight.company_1.id}`}
      target="_blank"
      style={{
        textDecoration: "none",
        color: "inherit",
      }}
    >
      <ListItem
        secondaryAction={
          <Tooltip title={Math.round(companyWeight.weight * 100) / 100}>
            <IconButton disableFocusRipple disableRipple sx={{ p: 0 }}>
              <SocialRating value={companyWeight.weight} />
            </IconButton>
          </Tooltip>
        }
      >
        <ListItemButton>
          <ListItemText
            primary={companyWeight.company_1.best_name}
            primaryTypographyProps={{
              noWrap: true,
              variant: "body2",
            }}
          />
          <ListItemText
            primary={companyWeight.company_1.best_domain}
            primaryTypographyProps={{
              noWrap: true,
              variant: "caption",
              width: "100%",
              textAlign: "end",
            }}
          />
        </ListItemButton>
      </ListItem>
    </Link>
  );
};

export default SocialCompanyListItemShort;
